import React, { useState } from 'react';
import useStyles from './style';
import clsx from 'clsx';

interface OutlinedAdornmentProps {
    /**
     * The content of the component, normally an `IconButton` or string.
     */
    children: React.ReactNode;
    /**
     * The position this adornment should appear relative to the `Input`.
     */
    position?: 'start' | 'end' | 'start-end';
    /**
     * If `true`, the control will be disabled.
     */
    disabled?: boolean;
    /**
     * If `true`, the label should be displayed in an error state.
     */
    error?: boolean;
}

const OutlinedAdornment: React.FC<OutlinedAdornmentProps> = ({
    children,
    position,
    disabled,
    error,
}: OutlinedAdornmentProps) => {
    const [focused, setFocused] = useState(false);
    const classes = useStyles();

    if (disabled && focused) {
        setFocused(false);
    }

    const onBlur = () => {
        setFocused(false);
    };

    const onFocus = () => {
        setFocused(true);
    };

    const className = clsx(classes.root, {
        [classes.positionStart]: position === 'start',
        [classes.positionEnd]: position === 'end',
        [classes.positionStartEnd]: position === 'start-end',
        [classes.focused]: focused,
        [classes.disabled]: disabled,
        [classes.error]: error,
    });

    return (
        <div data-testid="adornmentWrapper" onBlur={onBlur} onFocus={onFocus} className={className}>
            {children}
        </div>
    );
};

OutlinedAdornment.defaultProps = {
    disabled: false,
    error: false,
};

export { OutlinedAdornmentProps };
export default OutlinedAdornment;
